/**
 * FallbackBanner - hien thi khi TOC regex match 0 article (Dieu/Khoan).
 *
 * Spec: specs/M2-EXECUTION-PLAN-v2.md §4 P-A5 AC-9.
 * Khoang 30% van ban (cong van, thong bao, quyet dinh hanh chinh) khong co
 * cau truc Dieu/Khoan -> single-column render, hide TOC sidebar.
 */

export function FallbackBanner() {
  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        padding: '10px 14px',
        background: 'var(--asklaw-cream-deep)',
        border: '1px solid var(--asklaw-border)',
        borderRadius: 8,
        color: 'var(--asklaw-muted)',
        fontSize: 13,
        lineHeight: 1.55,
        fontFamily: 'var(--font-sans)',
        marginBottom: 14,
      }}
    >
      <span aria-hidden style={{ flexShrink: 0, marginTop: 2 }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
          <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </span>
      <span>
        Văn bản này không có cấu trúc Điều / Khoản. Hiển thị toàn văn theo bản gốc từ vbpl.vn.
      </span>
    </div>
  );
}
